__turbopack_context__.v({
  "desktopVideo": "ue2hna_desktopVideo",
  "mobileVideo": "ue2hna_mobileVideo",
  "subtitle": "ue2hna_subtitle",
  "textContainer": "ue2hna_textContainer",
  "title": "ue2hna_title",
  "videoContainer": "ue2hna_videoContainer",
  "videoWrapper": "ue2hna_videoWrapper",
});
